import MainButton from '@ui-kit/components/mainButton';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import React, { FormEvent, useState } from 'react';
import { container } from 'tsyringe';
import { ITicketService, StripeIntent } from '../model/interfaces';
import styles from '../styles/stripeForm.module.scss';
import { IMessage } from '@base/features/message/message';

export default function StripeForm(props: { stripeIntent: StripeIntent; onFinish: () => void }) {
  const message: IMessage = container.resolve('message');
  const ticketService: ITicketService = container.resolve('ticketsService');
  const [error, setError] = useState();
  const [processing, setProcessing] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const stripe = useStripe();
  const elements = useElements();

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setProcessing(true);
    if (!stripe || !elements) {
      return;
    }
    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);
    if (!cardElement) return;
    const payload = await stripe.confirmCardPayment(props.stripeIntent.client_secret, {
      payment_method: { card: cardElement },
    });

    if (payload.paymentIntent) {
      try {
        await ticketService.stripeConfirm(payload.paymentIntent.id);
        props.onFinish();
      } catch (e: any) {
        if (e.message) {
          message.error(e.message);
        }
      }
    }

    setProcessing(false);
    if (payload.error) {
      message.error(`Payment failed: ${payload.error}`);
    } else {
      message.success('Your payment was successful.');
    }
  }

  const handleChange = async (event: any) => {
    setDisabled(event.empty);
    setError(event.error ? event.error.message : '');
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit} className={styles.stripeContainer}>
      <CardElement
        id="card-element"
        className={styles.stripe}
        onChange={handleChange}
        options={{ style: { base: { color: 'white', iconColor: 'white' } } }}
      />
      <MainButton loading={processing} disabled={!stripe || disabled} type="submit">
        Pay via Stripe
      </MainButton>
      {error && (
        <div className={styles.cardError} role="alert">
          {error}
        </div>
      )}
    </form>
  );
}
